module.exports = __webpack_public_path__ + "img/about-bg1-m.24dc27d5.png";